import React from 'react'

import { Grid as GridBase, styled } from '@mui/material'

export const Root = styled('div')`
  margin: 20px 0 0;
  overflow: hidden;
  width: 100%;
`

export const Lane = styled(({ slideNumber, slideWidth, ...props }) => <div {...props} />)`
  display: grid;
  grid-template-columns: ${props => `${props.slideWidth} ${props.slideWidth} ${props.slideWidth}`};
  transform: translateX(${props => `calc(${props.slideWidth} * ${-(props.slideNumber - 1)})`});
  transition: transform 0.5s ease-out;
`

export const Slide = styled('div')``

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Image = styled('img')`
  width: 210px;
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 31px;
  margin: 0;
`

export const Subtitle = styled('span')`
  color: ${props => props.theme.palette.brand.black3};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  letter-spacing: 0;
  line-height: 21px;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
  margin: 0;
  max-width: 487px;
`

export const Dot = styled(({ active, ...props }) => <div {...props} />)`
  background-color: ${props => (props.active ? props.theme.palette.brand.primary : props.theme.palette.brand.gray2)};
  border-radius: 50%;
  display: inline-flex;
  height: 15px;
  margin: 9px;
  width: 15px;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.black3};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  text-decoration: underline;

  &:hover {
    color: ${props => props.theme.palette.brand.black2};
  }
`
